import React from "react";
import { Helmet } from "react-helmet-async";

const ContactSEO = () => {
  return (
    <Helmet>
      <title>Contact Themiya Induwara | Get in Touch</title>
      <meta
        name="description"
        content="Connect with Themiya Induwara Bandara - Full Stack Developer and Software Engineer. Available for freelance projects and collaborations."
      />
      <meta
        name="keywords"
        content="Contact Themiya, Hire Full Stack Developer, Sri Lankan Developer Contact, Themiya Induwara Contact, Software Engineer Contact"
      />
      <link rel="canonical" href="https://themiya.dev/contact" />
    </Helmet>
  );
};

export default ContactSEO;
